import { translateMessage } from "@/i18n";
import { NavLink } from "react-router-dom";
export interface BrandProps {
  compact?: boolean;
  showTagline?: boolean;
  to?: string;
}
export function Brand({ compact = false, showTagline = false, to = "/" }: BrandProps) {
  return (
    <NavLink
      aria-label={translateMessage("common.Brand.celsusHome")}
      className="inline-flex flex-col items-center rounded-sm text-ink hover:text-body focus:outline-none"
      to={to}
    >
      <img
        alt=""
        className={`brand-logo-light ${compact ? "h-auto w-12" : "h-auto w-28 min-[360px]:w-32 sm:w-40"}`}
        decoding="async"
        height="836"
        loading="eager"
        src="/brand/celsus-logo-primary.png?v=first-option"
        width="1881"
      />
      <img
        alt=""
        className={`brand-logo-dark hidden ${compact ? "h-auto w-12" : "h-auto w-28 min-[360px]:w-32 sm:w-40"}`}
        decoding="async"
        height="836"
        loading="eager"
        src="/brand/celsus-logo-dark.png"
        width="1882"
      />
      {!compact && showTagline && (
        <span className="-mt-2 hidden whitespace-nowrap text-[0.625rem] font-semibold uppercase leading-none tracking-[0.17em] text-muted min-[360px]:block">
          {translateMessage("common.Brand.legeFruereCommunica")}
        </span>
      )}
    </NavLink>
  );
}
